import React, { Component } from 'react';
import { Svg } from '../Gauge';
import {
   formatLabelIdAndId,
   GAUGE_CENTER_COORDINATES,
   GAUGE_STROKE_DEFAULT_COLOR,
   GaugeElementId,
   getValueBasedOnBounds,
   HALF_CIRCLE_DEGREES
} from '../shared/GaugeShared';
import { GaugeCenter } from './center/GaugeCenter';

export interface GaugeBodyProps {
   svg: Svg;
   svgId: string;
   value: number;
   colors: string[];
   colorPercentages: number[];
   upperBound: number;
   lowerBound: number;
   centerBackgroundColor: string;
}

export class GaugeBody extends Component<GaugeBodyProps> {
   private BODY_CIRCLE_RADIUS = 68;
   private BODY_CIRCLE_STROKE_WIDTH = 0.5;

   constructor(props: GaugeBodyProps) {
      super(props);

      this.drawGaugeBody(props);
   }

   render() {
      return (
         <GaugeCenter
            svg={this.props.svg}
            svgId={this.props.svgId}
            value={this.props.value}
            upperBound={this.props.upperBound}
            lowerBound={this.props.lowerBound}
            centerBackgroundColor={this.props.centerBackgroundColor}
         />
      );
   }

   UNSAFE_componentWillReceiveProps(nextProps: GaugeBodyProps): void {
      this.updateGaugeBodyBackgroundColor(nextProps);
   }

   drawGaugeBody = (props: GaugeBodyProps): void => {
      props.svg.draw.circle(this.BODY_CIRCLE_RADIUS)
         .center(GAUGE_CENTER_COORDINATES.x, GAUGE_CENTER_COORDINATES.y)
         .attr({
                  id: formatLabelIdAndId(GaugeElementId.BODY, props.svgId),
                  fill: this.getGaugeBodyBackgroundColorBasedOnCurrentAngle(props),
                  stroke: GAUGE_STROKE_DEFAULT_COLOR,
                  'stroke-width': this.BODY_CIRCLE_STROKE_WIDTH
               });
   };

   updateGaugeBodyBackgroundColor = (props: GaugeBodyProps): void => {
      props.svg.get(formatLabelIdAndId(GaugeElementId.BODY, props.svgId))
         .attr({
                  fill: this.getGaugeBodyBackgroundColorBasedOnCurrentAngle(props)
               });
   };

   getGaugeBodyBackgroundColorBasedOnCurrentAngle = (props: GaugeBodyProps): string => {
      const currentAngle: number = this.getCurrentAngleOfValue(props);
      let startAngle = 0;
      let endAngle = 0;

      for (let i = 0; i < props.colorPercentages.length; i++) {
         endAngle += HALF_CIRCLE_DEGREES * props.colorPercentages[i];

         if (currentAngle >= startAngle && currentAngle <= endAngle) {
            return props.colors[i];
         }

         startAngle = endAngle;
      }

      return props.colors[0];
   };

   getCurrentAngleOfValue = (props: GaugeBodyProps): number => {
      const lowerBound: number = props.lowerBound;
      const upperBound: number = props.upperBound;
      const range: number = upperBound - lowerBound;
      const percentIncrement: number = 1 / range;
      const value: number = getValueBasedOnBounds(props.value, lowerBound, upperBound);
      const percentValue: number = percentIncrement * (value - lowerBound);

      return Math.abs(percentValue * HALF_CIRCLE_DEGREES - HALF_CIRCLE_DEGREES);
   };
}
